import { render } from "./TextLinkBasic.vue?vue&type=template&id=54b6dae3&ts=true"
import script from "./TextLinkBasic.vue?vue&type=script&lang=ts"
export * from "./TextLinkBasic.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__